import styled from "styled-components";
import { useDarkMode } from "../context/DarkModeContext";
import MenuIconButton from "./MenuIconButton";
import logoDark from "../assets/images/logo-ext-dark.png";
import logoLight from "../assets/images/logo-ext-light.png";
import ToggleTheme from "./ToggleTheme";

const StyledHeader = styled.header`
  padding: 1rem 1.2rem;

  display: flex;
  gap: 2.4rem;
  align-tracks: center;
  justify-content: space-between;
  align-items: center;

  @media only screen and (max-width: 375px) {
    gap: 0;
  }

  background-color: var(--color-background);
`;

const LogoArea = styled.div`
  display: flex;
  gap: 1rem;
  align-items: center;

  @media only screen and (max-width: 375px) {
    gap: 0;
  }
`;

const ResponsiveMenu = styled.div`
  display: none;
  /* Medium devices (landscape tablets, 768px and up) */
  @media only screen and (max-width: 768px) {
    display: flex;
  }
`;

const Image = styled.img`
  height: 24px;

  @media only screen and (max-width: 320px) {
    display: none;
  }
`;
const Anchor = styled.a``;

function Header() {
  const { theme } = useDarkMode();

  const logo = theme !== "light" ? logoDark : logoLight;

  return (
    <StyledHeader>
      <LogoArea>
        <ResponsiveMenu>
          <MenuIconButton variant="secondary" />
        </ResponsiveMenu>
        <Anchor href="https://www.benthos.ai/" target="_blank">
          <Image src={logo} alt="Benthos Logo" loading="lazy" />
        </Anchor>
      </LogoArea>

      <ToggleTheme />
    </StyledHeader>
  );
}

export default Header;
